
<div>
    <div class="strength-meter" style="width:78%;margin-left:0;margin-top:-15px">
        <div class="strength-meter-fill" [style.background]="getMeterFillColor(passwordStrength)" [attr.data-strength]="idx"></div>
    </div>
</div>